'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_Option$() {
}
export { $c_s_Option$ as $c_s_Option$ };
$p = $c_s_Option$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
export { $h_s_Option$ as $h_s_Option$ };
$h_s_Option$.prototype = $p;
$p.B9 = (function(x) {
  return ((x === null) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(x));
});
var $d_s_Option$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_Option$, "scala.Option$", ({
  rB: 1
}));
export { $d_s_Option$ as $d_s_Option$ };
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
export { $m_s_Option$ as $m_s_Option$ };
